/*
 * @Author: etong
 * @Date: 2021-07-16 14:54:37
 * @LastEditTime: 2021-07-16 15:16:02
 * @LastEditors: your name
 * @Description:
 * @FilePath: \oak\src\directive\preventReClick\index.js
 * Think first, Program later
 */
import preventReClick from './preventReClick'

const install = function(Vue) {
  Vue.directive('preventReClick', preventReClick)
}

if (window.Vue) {
  window.preventReClick = preventReClick
  Vue.use(install); // eslint-disable-line
}

preventReClick.install = install
export default preventReClick
